<div class="policy-detail-container" *ngIf="!userDataLoading && (policyDetails !== undefined); else loading">
  <div class="grid align-center padding-medium padding-top-none">
    <div class="cell cell-large-col-span-6 cell-medium-col-span-8 cell-large-col-start-4">
      <div *ngIf="policyDetails.overdueInvoices?.count > 0">
        <open-tile-block
          [title]="policyDetails.overdueInvoices.count > 1 ? 'You have outstanding payments' : 'You have an outstanding payment'"
          [text]="'Retry or change your payment details'"
          (action)="retryPayment()"
          [tileClass]="'error-notification'"
        ></open-tile-block>
      </div>
  
      <div>
        <app-policy-hero-banner [data]="policyDetails"></app-policy-hero-banner>
        <app-policy-action [data]="policyDetails"></app-policy-action>
        <app-policy-link-cards [data]="policyDetails.claims.active" [policy]="policyDetails" [config]="claimsActiveConfig" *ngIf="policyDetails.claims && policyDetails.claims.active"></app-policy-link-cards>
        <app-policy-tiles class="policy-extras-tiles" [data]="policyDetails.extras.active" [config]="extrasActiveConfig" *ngIf="policyDetails.policyState !== 'cancelled' && policyDetails.extras && policyDetails.extras.active" [policy]="policyDetails"></app-policy-tiles>
        <app-policy-tiles class="policy-extras-tiles" [data]="policyDetails.extras.additional" [config]="extrasAdditionalConfig" *ngIf="policyDetails.policyState !== 'cancelled' && policyDetails.extras && policyDetails.extras.additional" [policy]="policyDetails"></app-policy-tiles>
        <app-policy-link-cards [data]="policyDetails.documents" [config]="policyDocumentConfig" [policy]="policyDetails" *ngIf="policyDetails.documents"></app-policy-link-cards>

        <app-policy-link-cards [data]="policyDetails.authorisedPersons" [config]="policyContactConfig" [policy]="policyDetails" *ngIf="policyDetails.authorisedPersons"></app-policy-link-cards>

        <app-policy-link-cards [data]="policyDetails.claims.completed" [config]="claimsCompletedConfig" *ngIf="policyDetails.claims.completed"></app-policy-link-cards>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!userDataLoading && isLoadingError">
  <div class="padding-medium padding-top-none">
    <div class="grid align-center">
      <div class="cell margin-right-medium margin-left-xmedium progress-nav">
        <button mat-icon-button color="primary" (click)="goBack()">
          <mat-icon>west</mat-icon>
        </button>
      </div>
      <div class="cell cell-large-col-span-12 padding-bottom-small open-form-info padding-small is-error">
        <p>Something went wrong</p>
      </div>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="padding-xxbig flex flex-justify-center">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</ng-template>
